class RegisterAccountPerks extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('.registration-popup--container form');
        this.parentContainer = document.querySelector('main');
        this.formErrorPopup = document.querySelector('#formErrorPopup');
        this.errorContainer = this.querySelector('.form-error');
        this.form.addEventListener('submit', this.submit.bind(this));
        this.emailField = this.form.querySelector('#register_email');
        this.pwdField = this.form.querySelector('#register_password');
        this.loginForm = document.getElementById('customer_login');
        this.loginEmailField = this.loginForm.querySelector('input[name="customer[email]"]');
        this.loginPwdField = this.loginForm.querySelector('input[name="customer[password]"]');

        sheerId.setOptions({mockRewardCode: null});
        /*sheerId.addHook({
            name: 'ON_VERIFICATION_READY',
            callback: (e) => {
                console.log('ON_VERIFICATION_READY');  
                console.log(e);
                sheerId.setOptions({mockRedirectUrl: `https://shopify-cache.obsessive.dev/techperks/manage_customer.php?verificationId=${e.verificationId}`});
            }
        });*/
        sheerId.addHook({
            name: 'ON_VERIFICATION_SUCCESS',
            callback: (e) => {
                console.log('ON_VERIFICATION_SUCCESS');
                console.log(e);
                if(e) {
                    if(e.hasOwnProperty('verificationId')) {
                        document.getElementById('sheer_verificationid').value = e.verificationId;
                    }
                    if(e.hasOwnProperty('subSegment')) {
                        document.getElementById('sheer_subsegment').value = e.subSegment;
                    }
                    if(e.hasOwnProperty('segment')) {
                        document.getElementById('sheer_segment').value = e.segment;
                    }
                }

                setTimeout(() => {
                    const successContainer = document.querySelector('#sid-step-success .sid-header');
                    if(successContainer) {
                        // const closeBtn = successContainer.closest('[data-sheer-form-container]').querySelector('[data-sheer-close]');
                        // if(closeBtn) closeBtn.setAttribute('disabled', '');
                        successContainer.innerHTML += `<br><a class="account-activate-link button button-primary" onclick="verifyAccount('${e.verificationId}')">Register Account</a>`;
                    }
                }, 700);
                // fetch(`https://shopify-cache.obsessive.dev/techperks/manage_customer.php?verificationId=${e.verificationId}`, {
                //     method: 'GET',
                //     headers: {
                //         'Content-Type': 'application/json',
                //         'Accept': 'application/json'
                //     }
                // })
                // .then((response) => response.json())
                // .then((data) => {
                //     console.log(data);
                //     const successContainer = document.querySelector('#sid-step-success .sid-header');
                //     if(data['success'] && successContainer) {
                //         if(data['activation_url']) {
                //             successContainer.innerHTML += `<br><a class="account-activate-link button button-primary" href="${data['activation_url']}">Activate your store account</a>`;
                //         } else {
                //             successContainer.innerHTML += `<br><a class="account-activate-link button button-primary" href="/account">Login your store account</a>`;
                //         }
                //     }
                // })
                // .finally(() => {
                //     const closeBtn = document.querySelector('[data-sheer-close][disabled]');
                //     if(closeBtn) closeBtn.removeAttribute('disabled');
                // });
            }
        });
        sheerId.addHook({
            name: 'ON_VERIFICATION_STEP_CHANGE',
            callback: (e) => {
            console.log('ON_VERIFICATION_STEP_CHANGE');
            console.log(e)
            }
        });

        this.sheeridLinks = this.querySelectorAll('a[data-sheerid]');
        this.sheeridLinks.forEach((link) => {
            this.initForm(link);
            link.addEventListener('click', this.displayVerification.bind(this));
        });

        // this.sheerIdForm = this.querySelector('.sheerid-form');
        // this.sheerIdForm.addEventListener('submit', this.verify.bind(this));
    }

    initForm(link) {
        const parent = link.closest('[data-sheer-wrapper]');
        // const form = parent.querySelector('[data-sheer-form]');
        const formWrapper = parent.querySelector('[data-sheer-form-container]');
        // const id = link.dataset.sheerid;
        const closeBtn = parent.querySelector('[data-sheer-close]');
        // const sheerForm = new sheerId.VerificationForm(form, id);
        closeBtn.addEventListener('click', () => {
            formWrapper.classList.add('hide');
            document.querySelector('body').classList.remove('no-scroll');
        });
    }

    submit(event) {
      /*console.log(1);
        event.preventDefault();
        this.clearErrors();
        this.form.classList.add('loading');
        this.loginEmailField.value = this.emailField.value;
        this.loginPwdField.value = this.pwdField.value;
        const data = new FormData(this.form);

        fetch('/account', {
            method: 'POST',
            body: data
        }).then((response) => response.json())
          .then((result) => {
            if(result.error) {
                this.showError(result.error);
            } else {
                this.showSuccess();
            }
          })
          .catch((err) => {
            this.showError(err);
          })
          .finally(() => {
              this.form.classList.remove('loading');
          });
        fetch('https://shopify-cache.obsessive.dev/techperks/customers.php', {
            method: 'POST',
            body: data
        }).then((response) => response.json())
          .then((result) => {
            if(result.error) {
                this.showError(result.error);
            } else {
                this.showSuccess();
            }
          })
          .catch((err) => {
            this.showError(err);
          })
          .finally(() => {
              this.form.classList.remove('loading');
          });*/
    }

    displayVerification(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const id = target.dataset.sheerid;
        
        const parent = target.closest('[data-sheer-wrapper]');
        const form = parent.querySelector('[data-sheer-form]');
        const formWrapper = parent.querySelector('[data-sheer-form-container]');
        formWrapper.classList.remove('hide');
        document.querySelector('body').classList.add('no-scroll');
        
        this.sheeridLinks.forEach((link) => {
            const p = link.closest('[data-sheer-wrapper]');
            const fWrapper = p.querySelector('[data-sheer-form-container]');
            const f = p.querySelector('[data-sheer-form]');
            if(link == target) {
                new sheerId.VerificationForm(form, id);
            } else {
                fWrapper.classList.add('hide');
                $(f).replaceWith('<div class="sheer-form" data-sheer-form></div>');
            }
        });

        // const verificationUrl = `https://services.sheerid.com/verify/${id}/`;
        // sheerId.loadInModal(
        //     verificationUrl, {
        //         mobileRedirect: true
        //     });
    }

    showError(error) {
        this.errorContainer.innerHTML = `<p>${error}</p>`;
    }

    showSuccess() {
        const successMsg = document.createElement('div');
        successMsg.className = 'custom-html--container';
        successMsg.innerHTML = '<div class="form-success"><p>Thank you for joining Tech Perks!</p></div>';
        this.formErrorPopup.insertBefore(successMsg, this.formErrorPopup.firstChild);
        window.scrollTo({top: 0, behavior: 'smooth'});

        setTimeout(() => {
            try {
                this.loginForm.submit();
            } catch (e) {
                console.error(e);
            }
            //window.location.href = "https://tech-perks.com/";
        }, 1000);
    }

    clearErrors() {
        this.errorContainer.innerHTML = '';
    }
}
customElements.define('register-account', RegisterAccountPerks);
